"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var highcharts_1 = __importDefault(require("highcharts"));

var highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));

var exporting_1 = __importDefault(require("highcharts/modules/exporting"));

var highcharts_export_csv_1 = __importDefault(require("highcharts-export-csv"));

if (typeof highcharts_1.default === 'object') {
  exporting_1.default(highcharts_1.default);
  highcharts_export_csv_1.default(highcharts_1.default);
}

function SzChart(_a) {
  var options = _a.options;
  return react_1.default.createElement(highcharts_react_official_1.default, {
    highcharts: highcharts_1.default,
    options: options
  });
}

exports.default = SzChart;